<template>
  <div class="member-contracts">
    <!-- Заключенные договоры -->
    <div class="contracts-section">
      <div class="contracts-group-header">Заключенные договоры</div>
      <div class="contract-row">
        <span class="contract-label"
          >Количество заключенных договоров строительного подряда, договоров
          подряда на осуществление сноса</span
        >
        <span class="contract-value">{{
          formatValue(contractConcludedCount)
        }}</span>
      </div>
      <div class="contract-row">
        <span class="contract-label"
          >Общий размер обязательств по заключенным договорам</span
        >
        <span class="contract-value">{{
          formatValue(contractConcludedTotalAmountLiability)
        }}</span>
      </div>
      <div class="contract-row">
        <span class="contract-label"
          >Фактический размер обязательств по предусматривающему наибольшую
          стоимость работ договору</span
        >
        <span class="contract-value">{{
          formatValue(contractConcludedFactTotalAmountLiability)
        }}</span>
      </div>
    </div>

    <!-- Заключенные конкурентными способами -->
    <div class="contracts-section">
      <div class="contracts-group-header">
        Заключенные конкурентными способами
      </div>
      <div class="contract-row">
        <span class="contract-label"
          >Количество договоров, заключенных конкурентными способами</span
        >
        <span class="contract-value">{{
          formatValue(contractConcludedCompetitiveMeansCount)
        }}</span>
      </div>
      <div class="contract-row">
        <span class="contract-label"
          >Фактический совокупный размер обязательств по договорам, заключенных
          конкурентными способами</span
        >
        <span class="contract-value">{{
          formatValue(contractConcludedCompetitiveMeansFactTotalAmountLiability)
        }}</span>
      </div>
    </div>

    <!-- Исполненные договоры -->
    <div class="contracts-section">
      <div class="contracts-group-header">Исполненные договоры</div>
      <div class="contract-row">
        <span class="contract-label"
          >Количество исполненных договоров подряда</span
        >
        <span class="contract-value">{{
          formatValue(contractExecutedCount)
        }}</span>
      </div>
      <div class="contract-row">
        <span class="contract-label"
          >Общий размер обязательств по исполненным договорам</span
        >
        <span class="contract-value">{{
          formatValue(contractExecutedTotalAmountLiability)
        }}</span>
      </div>
      <div class="contract-row">
        <span class="contract-label"
          >Количество исполненных договоров, заключенных конкурентными
          способами</span
        >
        <span class="contract-value">{{
          formatValue(contractExecutedCompetitiveMeansCount)
        }}</span>
      </div>
      <div class="contract-row">
        <span class="contract-label"
          >Фактический совокупный размер обязательств по исполненным договорам,
          заключенных конкурентными способами</span
        >
        <span class="contract-value">{{
          formatValue(contractExecutedCompetitiveMeansFactTotalAmountLiability)
        }}</span>
      </div>
    </div>

    <!-- Footer dates -->
    <div class="dates-footer">
      <div class="date-row">
        <div class="date-label">Дата создания:</div>
        <div class="date-value">
          {{
            getTimeFromDateTimeString(registryRegistrationDateTimeString) || '-'
          }}
        </div>
      </div>
      <div class="date-row">
        <div class="date-label">Обновлено:</div>
        <div class="date-value">
          {{
            lastUpdatedContractsAtDateTimeString
              ? getTimeFromDateTimeString(lastUpdatedContractsAtDateTimeString)
              : '-'
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTimeFromDateTimeString } from '../../helpers/helper'
export default {
  name: 'MemberContracts',
  props: {
    contractConcludedCount: {
      type: [Number, String],
      default: null
    },
    contractConcludedTotalAmountLiability: {
      type: [Number, String],
      default: null
    },
    contractConcludedFactTotalAmountLiability: {
      type: [Number, String],
      default: null
    },
    contractConcludedCompetitiveMeansCount: {
      type: [Number, String],
      default: null
    },
    contractConcludedCompetitiveMeansFactTotalAmountLiability: {
      type: [Number, String],
      default: null
    },
    contractExecutedCount: {
      type: [Number, String],
      default: null
    },
    contractExecutedTotalAmountLiability: {
      type: [Number, String],
      default: null
    },
    contractExecutedCompetitiveMeansCount: {
      type: [Number, String],
      default: null
    },
    contractExecutedCompetitiveMeansFactTotalAmountLiability: {
      type: [Number, String],
      default: null
    },
    contractConcludedDate: {
      type: String,
      default: null
    },
    contractExecutedDate: {
      type: String,
      default: null
    },
    contractConcludedOdoDate: {
      type: String,
      default: null
    },
    contractExecutedOdoDate: {
      type: String,
      default: null
    },
    registryRegistrationDateTimeString: {
      type: String,
      default: ''
    },
    lastUpdatedContractsAtDateTimeString: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const num = Number(value)
      if (!isNaN(num)) {
        const parts = num.toFixed(2).split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        // Если исходное значение было целым — убираем дробную часть
        if (Number.isInteger(num) && !String(value).includes('.')) {
          return parts[0]
        }
        return parts.join('.')
      }
      return value
    },
    getTimeFromDateTimeString
  }
}
</script>

<style scoped>
.member-contracts {
  max-width: 70%;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
}

.contracts-section {
  margin-bottom: 30px;
}

.contracts-group-header {
  text-align: center;
  font-weight: 700;
  border-radius: 4px 4px 0 0;
}

.contracts-group-title {
  text-align: center;
  font-weight: 700;
  margin-bottom: 10px;
}

.contract-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #e0e0e0;
}

.contract-label {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}

.contract-value {
  font-weight: 500;
  min-width: 50px;
  text-align: right;
}

.dates-footer {
  margin-top: 30px;
  text-align: center;
  padding-top: 20px;
}

.date-row {
  margin-bottom: 15px;
}

.date-label {
  font-weight: 700;
  margin-bottom: 5px;
}
</style>
